<template>
  <v-list-item
    :to="{ name: to }"
    :link="!!to"
    :class="{ 'pl-9': isSubmenu }"
    class="mb-1">
    <v-list-item-icon
      v-if="iconPrepend && icon"
      class="mr-4">
      <v-icon color="white">
        {{ icon }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-title class="white--text font-size">
      {{ title }}
    </v-list-item-title>

    <!-- <v-list-item-icon v-if="!iconPrepend && icon">
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-icon> -->
  </v-list-item>
</template>

<script>
export default {
  name: 'ListMenu',
  props: {
    title: {
      type: String,
      required: true
    },
    to: {
      type: [Object, String],
      default: undefined
    },
    icon: {
      type: String,
      default: undefined
    },
    iconPrepend: {
      type: Boolean,
      default: false
    },
    isSubmenu: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage () {
      return this.$route.name === this.to
    }
  }
}
</script>

<style lang="scss" scoped>
.font-size{
  font-size: 15px !important;
}
</style>
